import { render, staticRenderFns } from "./error-401.vue?vue&type=template&id=a2ec0064&"
import script from "./error-401.vue?vue&type=script&lang=ts&"
export * from "./error-401.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports